import React from 'react';

const Footer = () => (
  <footer className='footer'>
    <div className='heart'>
      <p>Made with <span className='heart__css'></span> by <a className='heart__author' href='https://simoneas02.github.io/' target='_blank'>Simone Amorim</a></p>
    </div>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js